import { useState } from "react";
import { downloadFile } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

export function ReceiptButton({ payment, size = "sm" }) {
  const [busy, setBusy] = useState(false);
  if (payment.status !== "confirmed") return null;
  const dl = async () => {
    setBusy(true);
    try { await downloadFile(`/payments/${payment.id}/receipt`, `receipt-${payment.period}-${payment.id.slice(0, 8)}.pdf`); toast.success("Receipt downloaded"); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <Button size={size} variant="ghost" className="h-8 gap-1.5 text-xs text-primary hover:bg-emerald-50" onClick={dl} disabled={busy} data-testid={`receipt-${payment.id}`}>
      <FileDown className="h-3.5 w-3.5" /> {busy ? "…" : "Receipt"}
    </Button>
  );
}
